module.exports = __webpack_public_path__ + "img/2.a26fe0d5.png";